(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3996],{

/***/ 63391:
/***/ (function(module) {

function webpackEmptyContext(req) {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
webpackEmptyContext.id = 63391;
module.exports = webpackEmptyContext;

/***/ }),

/***/ 46821:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/india/cart",
      function () {
        return __webpack_require__(367);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getServerSideProps": function() { return /* binding */ getServerSideProps; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52786);
/* harmony import */ var next_i18next_serverSideTranslations__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55709);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55111);
/* harmony import */ var _components_AemGrid__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72960);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34326);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73350);
/* harmony import */ var _components_Shared_GlobalPage_GlobalPageHeader__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(81169);
/* harmony import */ var _components_Shared_GlobalPage_GlobalPageFooter__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(74859);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(88751);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9473);
/* harmony import */ var _components_cart_Landing__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(82939);
/* harmony import */ var _components_cart_LandingFiller__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(22657);
/* harmony import */ var _components_PairsWellWith_PairsWellWith__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(75376);
/* harmony import */ var _components_Shared_UpsellInstallServices__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(24178);
















const Cart = (param)=>{
    let { tmpData: data , headertmp: header , footertmp: footer , ip , globalScript , footerScript , analyticsData , datalayerPageName , gbhDataLayerCustom  } = param;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.getDataLayerObj)(analyticsData);
    }, [
        analyticsData
    ]);
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_11__/* .useDispatch */ .I0)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_10__/* .setDatalayerPageName */ .dN)(datalayerPageName));
        dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_10__/* .setGbhDataLayerCustom */ .ks)(gbhDataLayerCustom));
        return ()=>{
            dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_10__/* .setDatalayerPageName */ .dN)(""));
            dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_10__/* .setGbhDataLayerCustom */ .ks)(""));
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_GlobalPage_GlobalPageHeader__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                header: header,
                title: data.title,
                globalScripting: globalScript
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_AemGrid__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                data: data,
                count: 0,
                upSellContainer: (data)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_UpsellInstallServices__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                        authData: data
                    }),
                landing: (data)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_cart_Landing__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        data: data
                    }),
                landingFiller: ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_cart_LandingFiller__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {}),
                pairsWellWith: (data)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PairsWellWith_PairsWellWith__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                        data: data
                    })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_GlobalPage_GlobalPageFooter__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                footer: footer,
                footerScripting: footerScript
            })
        ]
    });
};
/**
 * Get ServerSideProps together.
 * @param {Object} request The first number.
 * @return {object} The props.
 */ async function getServerSideProps(param) {
    let { req , locale  } = param;
    await (next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .i18n */ .ag === null || next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .i18n */ .ag === void 0 ? void 0 : next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .i18n.reloadResources */ .ag.reloadResources());
    const isPreviewMode = req.cookies["aem-author-preview-mode"];
    const ip = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.getClienIP)(req);
    const { data  } = isPreviewMode ? await (0,_constants_api__WEBPACK_IMPORTED_MODULE_7__/* .aemPreviewAxiosInstance */ .IT)({
        url: _constants__WEBPACK_IMPORTED_MODULE_4__.previewContentPrefix + _constants__WEBPACK_IMPORTED_MODULE_4__.cartDataUrl,
        method: "GET"
    }) : await (0,_constants_api__WEBPACK_IMPORTED_MODULE_7__/* .aemApimAxiosInstance */ .v0)({
        url: "".concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.buildUrlForAemApim)("".concat(_constants__WEBPACK_IMPORTED_MODULE_4__.cartDataUrl))),
        method: "GET"
    });
    const { data: header  } = isPreviewMode ? await (0,_constants_api__WEBPACK_IMPORTED_MODULE_7__/* .aemPreviewAxiosInstance */ .IT)({
        url: "".concat(data.headerExpFrg ? data.headerExpFrg : _constants__WEBPACK_IMPORTED_MODULE_4__.headerUrl, ".model.json"),
        method: "GET"
    }) : await (0,_constants_api__WEBPACK_IMPORTED_MODULE_7__/* .aemApimAxiosInstance */ .v0)({
        url: data.headerExpFrg ? (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.buildUrlForAemApim)("".concat(data.headerExpFrg, ".model.json")) : (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.buildUrlForAemApim)("".concat(_constants__WEBPACK_IMPORTED_MODULE_4__.headerUrl, ".model.json")),
        method: "get"
    });
    const { data: footer  } = isPreviewMode ? await (0,_constants_api__WEBPACK_IMPORTED_MODULE_7__/* .aemPreviewAxiosInstance */ .IT)({
        url: "".concat(data.footerExpFrg ? data.footerExpFrg : _constants__WEBPACK_IMPORTED_MODULE_4__.footerUrl, ".model.json"),
        method: "GET"
    }) : await (0,_constants_api__WEBPACK_IMPORTED_MODULE_7__/* .aemApimAxiosInstance */ .v0)({
        url: data.footerExpFrg ? (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.buildUrlForAemApim)("".concat(data.footerExpFrg, ".model.json")) : (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.buildUrlForAemApim)("".concat(_constants__WEBPACK_IMPORTED_MODULE_4__.footerUrl, ".model.json")),
        method: "GET"
    });
    const globalScript = data === null || data === void 0 ? void 0 : data.globalScript;
    const footerScript = data === null || data === void 0 ? void 0 : data.footerScript;
    const topHeadScript = (data === null || data === void 0 ? void 0 : data.topHeadScript) ? data === null || data === void 0 ? void 0 : data.topHeadScript : null;
    const gbhDataLayerCustom = {};
    if (data === null || data === void 0 ? void 0 : data.datalayerPageName) {
        gbhDataLayerCustom.datalayerPageName = data === null || data === void 0 ? void 0 : data.datalayerPageName;
    }
    if (data === null || data === void 0 ? void 0 : data.eventPageType) {
        gbhDataLayerCustom.eventPageType = data === null || data === void 0 ? void 0 : data.eventPageType;
    }
    if (data === null || data === void 0 ? void 0 : data.pageType) {
        gbhDataLayerCustom.pageType = data === null || data === void 0 ? void 0 : data.pageType;
    }
    let tmpData = {};
    if (data.pageComponentProperties) {
        tmpData = data.pageComponentProperties;
    } else {
        tmpData = data;
    }
    tmpData = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.filterBackEndJson)(tmpData);
    const headertmp = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.filterBackEndJson)(header);
    const footertmp = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.filterBackEndJson)(footer);
    var ref;
    const analyticsData = (ref = data === null || data === void 0 ? void 0 : data.data) !== null && ref !== void 0 ? ref : null;
    const datalayerPageName = data === null || data === void 0 ? void 0 : data.datalayerPageName;
    return {
        props: {
            ip,
            tmpData,
            headertmp,
            footertmp,
            globalScript,
            footerScript,
            topHeadScript,
            analyticsData,
            datalayerPageName,
            gbhDataLayerCustom,
            ...await (0,next_i18next_serverSideTranslations__WEBPACK_IMPORTED_MODULE_3__.serverSideTranslations)(locale, [
                "cart"
            ])
        }
    };
}
/* harmony default export */ __webpack_exports__["default"] = (Cart);


/***/ }),

/***/ 40816:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6351,1966,7333,8153,33,5709,1433,6051,5576,4178,5606,9377,2989,387,5376,8231,2082,6898,9774,2888,179], function() { return __webpack_exec__(46821); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);